import NormalIcon from './NormalIcon';

function App(props) {

  var text = props.text;
  if (text){
    return <NormalIcon height='14px' icon='gg:details-more' title={text}/>
  }else{
    return null;
  }
}

//
export default App;
